import React from "react";
import { useTranslation } from "react-i18next";

import useFormatDays from "../../hooks/useFormatDays";
import { setArticleDataToStore } from "../../store/ArticleStore";
import { useDispatch } from "react-redux";

interface NewsItemLayoutProps {
  type: string;
  date?: any;
  title: string;
  intro: string;
  image?: string;
  description: string;
  image_copyright_text: string;
  articleslug?: string;
}

function NewsItemLayout({
  type,
  date = "",
  title,
  intro,
  image = "",
  description,
  image_copyright_text = "",
  articleslug = "",
}: NewsItemLayoutProps) {
  const { t } = useTranslation();
  const formattedDate = useFormatDays(date);
  const dispatch = useDispatch();
  

  return (
    <>
      <div className="flex justify-between">
        <div className="flex flex-col ">
          <div className="news-type icon">{t(`news.${type}`)}</div>
          {date ? (
            <div className="news-date">{formattedDate}</div>
          ) : (
            <div className="news-date"></div>
          )}
        </div>
        {type === "article" && articleslug && articleslug.length && (
          <button
            onClick={() => {
              dispatch(
                setArticleDataToStore([{ articleslug: articleslug, isShared: true }])
              );
            }}
            className="share-button h-fit gap-2 button bg-slate-400 mb-5 flex"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-share2-icon lucide-share-2"
            >
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
              <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
            </svg>
            Teilen
          </button>
        )}
      </div>
      {image && (
        <div className="news-image">
          <img src={image} alt={title} />
          {image_copyright_text && (
            <figcaption>{image_copyright_text}</figcaption>
          )}
        </div>
      )}
      <h1>{title}</h1>
      <div className="news-description">
        <div
          className="news-intro"
          dangerouslySetInnerHTML={{ __html: intro }}
        />
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </>
  );
}

export default NewsItemLayout;
